'use client';

import { SvgBookmarkFill, SvgBookmarkOutline } from '@common/icon';
import { cn } from '@core/utils';

interface BookmarkButtonProps {
  bookmarkCount?: number;
  isBookmarked?: boolean;
  onClick?: (isBookmarked: boolean) => void;
}

export const BookmarkButton = ({
  // bookmarkCount = 0,
  isBookmarked = false,
  onClick,
}: BookmarkButtonProps) => {
  return (
    <div className="flex items-center gap-10">
      <button
        className="group h-36 gap-4 rounded-pill border border-Gray-300 px-16 flex-center"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onClick?.(isBookmarked);
        }}
      >
        {isBookmarked ? (
          <SvgBookmarkFill
            fill="none"
            className={cn('size-14 fill-none text-B-500')}
          />
        ) : (
          <SvgBookmarkOutline originalFill className={cn('size-14')} />
        )}

        <span className="text-Gray-700 typo-body4">스크랩</span>
      </button>
    </div>
  );
};
